import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box, Typography } from "@mui/material";
import StyledModal from "../../../Modals/StyledModal/StyledModal";
import PrimarySelect from "../../../Inputs/PrimarySelect/PrimarySelect";
import PrimaryButton from "../../../Buttons/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../../Buttons/SecondaryButton/SecondaryButton";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import UploadFileButton from "../../../Buttons/UploadFileButton/UploadFileButton";
import { ImageService } from "../../../../services/ImageService";
import { AlertContext } from "../../../Dashboard/Dashboard";

export default function LoadProfileUploadDocumentModal({
  activeLoad,
  acceptedFiles,
  setRefreshDocuments
}) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [document, setDocument] = useState({});
  const [documentType, setDocumentType] = useState("");
  const [documentTypes, setDocumentTypes] = useState([]);

  const handleReset = () => {
    setDocument({});
    setDocumentType("");
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    handleReset();
  };

  const handleCancel = () => {
    handleClose();
  };

  const handleSave = () => {
    if (document) {
      let payload = new FormData();
      payload.append("rowType", "O");
      payload.append("rowId", activeLoad.id);
      payload.append("documentTypeId", documentType);
      payload.append("file", document);

      ImageService.UploadDocument(instance, payload).then(() => {
        setIsLoading(false);
        setRefreshDocuments(true);
        handleClose();
      }).catch(error => {
        console.error(error);
        setIsLoading(false);
        warning(error);
      });
    }
  };

  const handleUploadFile = (ev) => {
    if (ev.target?.files) {
      setDocument(ev.target.files[0]);
    } else {
      setDocument(ev[0]);
    }
  };

  useEffect(() => {
    if (acceptedFiles?.length) {
      handleUploadFile(acceptedFiles);
      //TODO Uncomment when feature exists
      //handleOpen();
    }
  }, [acceptedFiles]);

  useEffect(() => {
    if (open) {
      ImageService.GetDocumentTypes(instance, "O", activeLoad.id).then(res => {
        setDocumentTypes(res);
        setIsLoading(false);
      }).catch(error => {
        console.error(error);
        setIsLoading(false);
        warning(error);
      });
    }
  }, [open]);

  return (
    <Box>
      {/*TODO Uncomment when feature exists*/}
      {/*<SecondaryButton*/}
      {/*  label="Upload"*/}
      {/*  onClick={handleOpen}*/}
      {/*  startIcon={FileUploadOutlinedIcon}*/}
      {/*  size="small"*/}
      {/*/>*/}
      <StyledModal
        label="Upload Document"
        title="Upload Document"
        open={open}
        handleClose={handleClose}
      >
        <Box sx={{ maxWidth: "300px", overflowY: "auto", display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" color="black_opacity.100">
            Select a file from your computer and then designate which required document it aligns to.
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", marginY: "20px" }} >
            <UploadFileButton
              label="Attach"
              onChange={handleUploadFile}
              startIcon={AttachFileOutlinedIcon}
              width="100px"
            />
            <Typography variant="body1" color="black_opacity.80" marginLeft="5px">
              {document?.name ?? "No file selected"}
            </Typography>
          </Box>
          <PrimarySelect
            label="Document Type"
            options={documentTypes}
            onChange={setDocumentType}
            value={documentType}
            nameKey="description"
            valueKey="id"
            error={!documentType}
          />
        </Box>
        <Box sx={{ display: "flex", marginTop: "20px" }}>
          <Box sx={{ marginLeft: "auto", padding: "5px 10px 5px 5px" }}>
            <SecondaryButton
              label="Cancel"
              onClick={handleCancel}
              disabled={isLoading}
            />
          </Box>
          <Box sx={{ padding: "5px 0 5px 5px" }}>
            <PrimaryButton
              label="Submit"
              width="60px"
              onClick={handleSave}
              isLoading={isLoading}
              disabled={!document?.name || !documentType}
            />
          </Box>
        </Box>
      </StyledModal>
    </Box>
  );
}

LoadProfileUploadDocumentModal.propTypes = {
  activeLoad: PropTypes.object.isRequired,
  acceptedFiles: PropTypes.array,
  setRefreshDocuments: PropTypes.func
};